import { getDirection, setDirection } from '../store/line-store.js'

import { lineSelected } from '../utils/dom-utils.js'

export class DirectionButtonElement extends HTMLElement {
	constructor() {
		super()

		const button = document.createElement('button')
		button.textContent = getDirection() == 'Retour' ? 'Retour' : 'Aller'

		button.addEventListener('click', () => {
			button.textContent = getDirection() == 'Retour' ? 'Aller' : 'Retour'
			setDirection(getDirection() == 'Retour' ? 'Aller' : 'Retour')

			lineSelected()
		})

		this.appendChild(button)
	}
}

customElements.define('direction-button', DirectionButtonElement)
